export const enTopupCredits = {
	title: "Top up credits",
	description:
		"Purchase additional credits as a one-time payment. Credits will be added to your account immediately after payment.",
	selectAmount: "Select amount",
	customAmount: "Or enter custom amount",
	pricePerCredit: "Price per credit",
	netPrice: "Net price",
	vat: "VAT/Tax",
	vatWithPercentage: "VAT ({{percentage}}%)",
	taxExempt: "€0.00 (tax exempt)",
	total: "Total",
	forCredits: "for {{credits}} credits",
	buyButton: "Buy {{credits}} credits",
	calculatingPrice: "Calculating price…",
	selectAmountToSeePrice: "Select an amount to see the price breakdown",
	errors: {
		generic: "Something went wrong. Please try again.",
	},
};
